/** @jsxImportSource @emotion/react */
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";

// Hooks
import useAppRoutes from "../common/hooks/use-app-routes";
import {useAuth} from "../auth/auth";

// Components
import NavItem from "./nav-item";
import {Icon, Menu, MenuDivider, MenuItem} from "@blueprintjs/core";
import {primaryColor} from "../common/libs/theme-lib";
import Popover from "../common/components/popover";

const Navigation = (props) => {

    // Hooks
    const routesMetaData = useAppRoutes();
    const {pathname} = useLocation();
    const history = useHistory();
    const {userType, features} = useAuth();

    // Props
    const {isAdminHeader} = props;

    // State
    const [isIconNav, setIsIconNav] = useState(window.innerWidth < 1165);

    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsIconNav(window.innerWidth < 1165);
        });
    }, []);

    if (isIconNav) {
        return (
            <>
                <div style={{flex: 1}} />
                <Popover
                    content={(
                        <Menu>
                            {routesMetaData.filter(route => route.isAdminRoute === isAdminHeader).map(({text, to}, index) => {
                                const feature = to.substring(1);
                                return (userType === "admin" || (userType === "client" && (features.indexOf(feature) >= 0)) || feature === "home"
                                    ? (
                                        <MenuItem
                                            key={index}
                                            text={text}
                                            active={pathname === to}
                                            onClick={() => history.push(to)}
                                        />
                                    ) : null
                                );
                            })}
                        </Menu>
                    )}
                    position="bottom"
                >
                    <div
                        css={{
                            cursor: "pointer",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: "all 0.4s",
                            "&:hover": {
                                color: isAdminHeader ? primaryColor : "black",
                            }
                        }}
                    >
                        <Icon icon="menu" iconSize={36}/>
                    </div>
                </Popover>
            </>
        );
    }

    return (
        <div style={{
            flex: 1,
            display: "flex"
        }}>
            {routesMetaData.filter(route => route.isAdminRoute === isAdminHeader).map(({text, to}, index) => {
                const feature = to.substring(1);
                return (userType === "admin" || (userType === "client" && (features.indexOf(feature) >= 0)) || feature === "home"
                    ? (
                        <NavItem
                            key={index}
                            text={text}
                            isActive={pathname === to}
                            to={to}
                        />
                    ) : null
                );
            })}
        </div>
    );
};

export default Navigation;